var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = "__";

  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QtyInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(e) {
    e.preventDefault();
    const previousValue = this.input.value;

    if (e.target.name === "btn_plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const btnMinus = this.querySelector(".quantity_minus_button");
      btnMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const btnPlus = this.querySelector(".quantity_plus_button");
      btnPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("qty-input", QtyInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

// ACCORDION
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".accordion_item");

  items.forEach((item) => {
    const header = item.querySelector(".accordion_header");
    const content = item.querySelector(".accordion_content");
    const plus = header.querySelector(".plus_vertical");

    header.addEventListener("click", () => {
      items.forEach((otherItem) => {
        const otherContent = otherItem.querySelector(".accordion_content");
        const plus = otherItem.querySelector(".plus_vertical");

        if (otherContent !== content) {
          closeAccordion(otherContent, plus);
        }
      });

      if (content.style.height && content.style.height !== "0px") {
        closeAccordion(content, plus);
        plus.classList.remove("rot");
      } else {
        openAccordion(content, plus);
      }
    });
  });

  function openAccordion(el, plus) {
    el.style.height = el.scrollHeight + "px";
    plus.classList.add("rot");
    el.closest(".accordion_item").classList.add("open");
  }

  function closeAccordion(el, plus) {
    el.style.height = "0";
    plus.classList.remove("rot");
    el.closest(".accordion_item").classList.remove("open");
  }
});

// PRODUCT INFO
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      qtyInput = undefined;
      qtyForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.Button = this.querySelector('[type="submit"]');
        this.ButtonText = this.Button.querySelector("span");
        this.images = [...this.querySelectorAll(".product_media")];
        this.qtyInput = this.querySelector(".qty_input");
        this.qtyForm = this.querySelector(".product_quantity_selector_wrapper");       
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleVariantChange.bind(this)
        );

        this.initQtyHandlers();

        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQtyHandlers() {
        if (!this.quantityInput) return;
        if (!this.quantityForm) return;

        this.setQtyBorders();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQtyRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      handleVariantChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;

        this.pendingRequestUrl = productUrl;
        const shouldSwap = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwap;

        this.loadProductInfo({
          requestUrl: this.buildRequestUrl(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwap
            ? this.swapProductContent(productUrl, shouldFetchFullPage) // handleSwapProduct
            : this.updateProductContent(productUrl), // handleUpdateProductInfo
        });
      }

      resetFormState() {
        this.setSubmitButtonState(this.Button, true); // toggleSubmitButton
        this.productForm?.handleErrorMessage();
      }

      buildRequestUrl(url, optionValues, fetchFullPage = false) {
        const params = [];
        if (!fetchFullPage) {
          params.push(`section_id=${this.sectionId}`);
        }

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      setQtyBorders() {
        const data = {
          cartQuantity: this.qtyInput.dataset.cartQuantity
            ? parseInt(this.qtyInput.dataset.cartQuantity)
            : 0,
          min: this.qtyInput.dataset.min
            ? parseInt(this.qtyInput.dataset.min)
            : 1,
          max: this.qtyInput.dataset.max
            ? parseInt(this.qtyInput.dataset.max)
            : null,
          step: this.qtyInput.step ? parseInt(this.qtyInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.qtyInput.min = min;

        if (max) {
          this.qtyInput.max = max;
        } else {
          this.qtyInput.removeAttribute("max");
        }
        this.qtyInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      updateProductContent(productUrl) {
        return (html) => {
          const variant = this.extractSelectedVariant(html); // getSelectedVariant

          this.replaceOptionValues(html); // updateOptionValues
          this.updateBrowserURL(productUrl, variant?.id); // updateURL
          this.updateVariantInputFields(variant?.id); // updateVariantInputs
          this.pickupAvailability?.update(variant);

          if (!variant) {
            this.setProductUnavailable(); // setUnavailable
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id, variant?.featured_media);

          const updateSection = (id, shouldHide = () => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const target = this.querySelector(`#${id}-${this.sectionId}`);
            if (source && target) {
              target.innerHTML = source.innerHTML;
              target.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSection("price");
          updateSection("sku", (el) => el.classList.contains("hidden"));
          updateSection("inventory", (el) => el.innerText === "");

          this.updateQtyRules(this.sectionId, html);

          this.querySelector(
            `#Quantity-Rules-${this.sectionId}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.sectionId}`
          )?.classList.remove("hidden");

          this.setSubmitButtonState(
            this.Button,
            !variant?.available,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      loadProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((res) => res.text())
          .then((htmlString) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              htmlString,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((err) => {
            if (err.name !== "AbortError") {
              console.error(err);
            }
          });
      }

      extractSelectedVariant(productInfoNode) {
        const data = productInfoNode.querySelector(
          "variant-picker [data-selected-variant]"
        )?.innerHTML;
        return data ? JSON.parse(data) : null;
      }

      replaceOptionValues(html) {
        const picker = html.querySelector("variant-picker");
        if (picker) {
          HTMLUpdateUtility.viewTransition(
            this.activeVariantPicker, // variantPickers
            picker,
            this.preProcessHtmlCallbacks
          );
        }
      }

      fetchQtyRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQtyRules(this.sectionId, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQtyRules(sectionId, html) {
        if (!this.qtyInput) return;
        this.setQtyBorders();
        const qtyFormUpdated = html.getElementById(
          `quantity_form-${sectionId}`
        );
        const selectors = [".qty_input", ".qty_label"];
        for (let selector of selectors) {
          const current = this.qtyForm.querySelector(selector);
          const updated = qtyFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".qty_input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get activeVariantPicker() {
        return this.querySelector("variant-picker");
      }

      updateBrowserURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;

        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      updateVariantInputFields(variantId) {
        this.querySelectorAll(
          `#product-form--${this.sectionId}, #product-form-installment--${this.sectionId}`
        ).forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      setSubmitButtonState(button, disabled = true, label) {
        if (!button) return;

        const stickyBtn = document.querySelector(
          ".sticky_add_to_cart_inner button"
        );

        const span = button.querySelector("span");
        if (!span) return;

        if (disabled) {
          button.setAttribute("disabled", "disabled");
          button.classList.add("btn_disabled");
          if (label) span.textContent = label;
          if (stickyBtn) {
            stickyBtn.setAttribute("disabled", "disabled");
            stickyBtn.classList.add("btn_disabled");
            stickyBtn.querySelector("span").textContent = label;
          }
        } else {
          button.removeAttribute("disabled");
          button.classList.remove("btn_disabled");
          span.textContent = window.variantStrings.addToCart;
          if (stickyBtn) {
            stickyBtn.removeAttribute("disabled");
            stickyBtn.classList.remove("btn_disabled");
            stickyBtn.querySelector("span").textContent =
              window.variantStrings.addToCart;
          }
        }
      }

    updateMedia(html, variantFeaturedMediaId, variantFeaturedMedia) {
      if (!variantFeaturedMediaId) return;

      const mediaGallerySource = this.querySelector("media-gallery .media_inner");
      const mediaGalleryDestination = html.querySelector("media-gallery .media_inner");
      const mobileSlider = this.querySelector(".product_mobile_slider.stacked_on_desktop");
      const desktopSlider = this.querySelector(".product_media_slider.slider_desktop");

      // Detect screen size
      const isMobile = window.matchMedia("(max-width: 989px)").matches;

      // Detect which layout is actually *visible*
      const isDesktopSliderVisible =
        desktopSlider &&
        window.getComputedStyle(desktopSlider).display !== "none";

      const isMobileSliderVisible =
        mobileSlider &&
        window.getComputedStyle(mobileSlider).display !== "none" &&
        isMobile;

      const isGridVisible =
        mediaGallerySource &&
        window.getComputedStyle(mediaGallerySource).display !== "none";

      // ✅ CASE 1: Slider (desktop or mobile)
      if (isDesktopSliderVisible || isMobileSliderVisible) {
        const id = `${this.sectionId}-${variantFeaturedMediaId}`;
        const mediaGallery = document.querySelector("media-gallery");

        if (mediaGallery) {
          mediaGallery.dispatchEvent(
            new CustomEvent("variant-media-change", {
              detail: { mediaId: id },
            })
          );
        }

        // Highlight active media in mobile slider
        if (isMobileSliderVisible && mobileSlider) {
          const mobileMedia = mobileSlider.querySelector(
            `[data-media-id="${variantFeaturedMediaId}"]`
          );
          if (mobileMedia) {
            mobileSlider
              .querySelectorAll(".product_media_wrapper")
              .forEach((el) => el.classList.remove("active"));
            mobileMedia.classList.add("active");
          }
        }

        return; 
      }

      // ✅ CASE 2: GRID layout (stacked on desktop)
      const refreshSourceData = () => {
        const mediaGallerySourceItems = Array.from(
          mediaGallerySource.querySelectorAll(".product_media_wrapper")
        );
        const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
        const sourceMap = new Map(
          mediaGallerySourceItems.map((item, index) => [
            item.dataset.mediaId,
            { item, index },
          ])
        );
        return [mediaGallerySourceItems, sourceSet, sourceMap];
      };

      if (isGridVisible && mediaGallerySource && mediaGalleryDestination) {
        let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        const mediaGalleryDestinationItems = Array.from(
          mediaGalleryDestination.querySelectorAll(".product_media_wrapper")
        );
        const destinationSet = new Set(
          mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
        );

        let shouldRefresh = false;

        // Add missing items
        for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
          if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
            mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
            shouldRefresh = true;
          }
        }

        // Remove extra items
        for (let i = 0; i < mediaGallerySourceItems.length; i++) {
          if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
            mediaGallerySourceItems[i].remove();
            shouldRefresh = true;
          }
        }

        if (shouldRefresh) {
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }

        // Reorder items
        mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
          const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
          if (sourceData && sourceData.index !== destinationIndex) {
            mediaGallerySource.insertBefore(
              sourceData.item,
              mediaGallerySource.querySelector(
                `.product_media_wrapper:nth-of-type(${destinationIndex + 1})`
              )
            );
            [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          }
        });
      }
    }

      preloadImage(url) {
        const sizes = [352, 832, 1200];
        sizes.forEach((width) => {
          const img = new Image();
          img.src = `${url}&width=${width}`;
        });
      }

      setProductUnavailable() {
        this.setSubmitButtonState(
          this.Button,
          true,
          window.variantStrings.unavailable
        );
      }

      swapProductContent(productUrl, shouldFetchFullPage) {
        return this.updateProductContent(productUrl);
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

// PRODUCT ADD TO CART FORM
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.recommendedProducts = this.closest("recommended-products");
        this.cart = document.querySelector(".main_cart_drawer ");
        this.submitButton = this.querySelector?.('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector("span");
      }

      handleSubmit(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const loader = this.submitButton.querySelector('.loader');
        const iconWrapper = this.submitButton.querySelector('.icon_wrapper');
        if(loader) {
          loader.classList.remove('hidden')
        }
        if(iconWrapper) {
          iconWrapper.classList.add('hidden');
        }
        this.querySelector(".loader").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (
                response.description !==
                "The maximum quantity of this item is already in your cart."
              ) {
                fetch("/cart.js")
                  .then((res) => res.json())
                  .then((cart) => {
                    if (this.cart) {
                      updateCartDrawer(cart, cart.item_count);
                    } else {
                      const bubbles = document.querySelectorAll(
                        "#cart-icon-bubble .cart-count-text"
                      );
                      const bubbleHiddens = document.querySelectorAll(
                        "#cart-icon-bubble .visually-hidden"
                      );

                      bubbles.forEach((bubble) => {
                        if (bubble.classList.contains("hide_on_desktop")) {
                          bubble.querySelector("span.cc_text").textContent =
                            cart.item_count;
                        } else {
                          bubble.querySelector(
                            "span.cc_text"
                          ).textContent = `(${cart.item_count})`;
                        }
                      });

                      bubbleHiddens.forEach((bubbleHidden) => {
                        bubbleHidden.textContent = `${cart.item_count} items`;
                      });
                    }
                  })
                  .catch((err) =>
                    console.error("Failed to fetch cart data:", err)
                  );
              }

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = `${window.Shopify.routes.root}cart`;
              return;
            } else {
              fetch("/cart.js")
                .then((res) => res.json())
                .then((cartData) => {
                  updateCartDrawer(cartData, cartData.item_count);
                  setTimeout(() => {
                    this.openDrawer(
                      document.querySelector(".main_cart_drawer"),
                      this.submitButton
                    );
                  }, 300);
                });

              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            const iconWrapper = this.submitButton.querySelector('.icon_wrapper');
            if(iconWrapper) {
              iconWrapper.classList.remove('hidden');
            }
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loader").classList.add("hidden");
            const stickyBtn = document.querySelector(
              ".sticky_add_to_cart_inner button"
            );
            if (stickyBtn) {
              stickyBtn.querySelector(".loader").classList.add("hidden");
            }
          });
      }

      openDrawer(drawer, button) {
        this.closeAllDrawers();
        let lastFocusedButton = null;
        if (drawer) {
          lastFocusedButton = button;

          drawer.classList.add("active");
          drawer.setAttribute("aria-hidden", "false");
          document.body.classList.add("overflow-hidden");

          const focusableElements = drawer.querySelectorAll("button, input, a");
          if (focusableElements.length) {
            focusableElements[0].focus();
          }

          drawer.addEventListener("keydown", (event) =>
            trapFocus(event, drawer)
          );
        }
      }

      closeAllDrawers() {
        const drawers = document.querySelectorAll(".main_drawer");

        drawers.forEach((drawer) => {
          drawer.classList.remove("active");
          drawer.setAttribute("aria-hidden", "true");
          document.body.classList.remove("overflow-hidden");
          //  document.querySelector(".header-section").style.zIndex = "4";
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".error_message_wrapper") || this.closest('product-card').querySelector('.error_message_wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".error_message_text");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

// COLLECTION LIST
class CollectionList extends HTMLElement {
  constructor() {
    super();
    this.blocks = this.querySelectorAll('.collection_list_block');
  }

  connectedCallback() {
    this.blocks.forEach((block) => {
      const link = block.querySelector('a.btn');
      if(!link) return;
      link.addEventListener('focusin', (e) => {
        const el = e.target;
        if(el.matches(':focus-visible')) {
          link.closest('.collection_list_info').style.transform = 'scale(1)';
        }
      })

      link.addEventListener('blur', (e) => {
        const el = e.target;
          link.closest('.collection_list_info').style.transform = 'scale(0)';        
      })
    })
  }

}

customElements.define("collection-list", CollectionList);

// VIDEO SECTION
class VideoSection extends HTMLElement {
  constructor() {
    super();
   
    this.playIcon = this.querySelector(".play_icon_wrapper");
    this.imageContainer = this.querySelector(
      ".video_section_poster_image_wrapper"
    );
    this.videoContainer = this.querySelector(".video_section_video_wrapper");
    this.video = this.videoContainer?.querySelector("video");
    this.iframe = this.videoContainer?.querySelector("iframe");

   
  }

  connectedCallback() {   
    if (this.playIcon && this.imageContainer && this.videoContainer) {
      this.playIcon.addEventListener("click", this.handleClick);
    }

    if(this.video) {
      this.video.addEventListener('click', this.handleVideoClick.bind(this));
    }
  }

  disconnectedCallback() {
    this.playIcon?.removeEventListener("click", this.handleClick);
  }

  handleVideoClick() {
    if(this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  handleClick = () => {
    if (!this.video && !this.iframe) return;

    this.imageContainer.classList.add("nodisp");

    setTimeout(() => {
      this.imageContainer.style.display = "none";
      this.videoContainer.style.display = "block";
      requestAnimationFrame(() => this.videoContainer.classList.add("disp"));

      if (this.video) {
        this.video.play();
      } else if (this.iframe) {
        const src = this.iframe.getAttribute("src");
        if (src.includes("youtube.com") || src.includes("youtu.be")) {
          this.iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        } else if (src.includes("vimeo.com")) {
          this.iframe.contentWindow.postMessage(
            '{"method":"play"}',
            "https://player.vimeo.com"
          );
        }
      }
    }, 500);
  };
}

customElements.define("video-section", VideoSection);

// FEATURED COLLECTION
class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.featured_collection_slider');
    this.spacing = this.dataset.spacing;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobColumns;
  } 

  connectedCallback() {
    if(!this.slider) return;
    this.swiper = new Swiper(this.slider, {
      slidesPerView: this.columns,
      spaceBetween: this.spacing,
      speed: 800,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        0: {
          slidesPerView: this.mobColumns,
          spaceBetween: 15    
        },
        640:{
          slidesPerView: 2,
          spaceBetween: this.spacing
        },
        768: {
          slidesPerView: 3,
          spaceBetween: this.spacing
        },
        1299: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing
        }
      }
    })
  }
  
}

customElements.define("featured-collection", FeaturedCollection);

// IMAGE GALLERY
class ImageGallery extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.image_gallery_slider');
    this.columns = this.dataset.columns;
    this.spacing = this.dataset.spacing;
    this.galleryBlocks = this.querySelectorAll('.image_gallery_block');
  }

  connectedCallback() {
    if(!this.slider) return;
    const self = this;
    this.swiper = new Swiper(this.slider, {
      slidesPerView: this.columns,
      spaceBetween: this.spacing,
      speed: 800,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      on: {
        sliderMove(swiper, e) {
          if(!self.galleryBlocks) return;
          self.galleryBlocks.forEach((galleryBlock) => {
            galleryBlock.classList.add('tilt');
          })
        }, 
        touchEnd(swiper, e) {
          if(!self.galleryBlocks) return;
          self.galleryBlocks.forEach((galleryBlock) => {
            galleryBlock.classList.remove('tilt');
          })
        }
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        640: {
          slidesPerView: 2,
          spaceBetween: this.spacing
        },
        768: {
          slidesPerView: 3,
          spaceBetween: this.spacing
        },
        1299: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing
        }
      }
    })
  }
}

customElements.define("image-gallery", ImageGallery);

// IMAGE BANNER
class ImageBanner extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelectorAll(".image_banner_img_wrapper");
    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px -300px 0px",
    });
  }

  connectedCallback() {
    this.images.forEach((image) => this.observer.observe(image));
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.style.filter = "blur(0)";
        });
      }
    });
  };
}

customElements.define("image-banner", ImageBanner);

// SPLIT BANNER
class SplitBanner extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelectorAll(".split_banner_block");
    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px -300px 0px",
    });
  }

  connectedCallback() {
    this.images.forEach((image) => this.observer.observe(image));
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.style.filter = "blur(0)";
        });
      }
    });
  };
}

customElements.define("split-banner", SplitBanner);

// SHOP THE COLLECTION
class ShopTheCollection extends HTMLElement {
  constructor() {
    super();
    this.images = [
      ...this.querySelectorAll(
        ".product_card, .empty_product_card, .shop_the_collection_featured_img"
      ),
    ];
    this.links = this.querySelectorAll(".shop_the_collection_link");

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px -300px 0px",
    });

    this.linkObserver = new IntersectionObserver(this.handleLinkObserver, {
      rootMargin: "0px 0px -200px 0px",
    });
  }

  connectedCallback() {
    if (this.images.length) {
      this.images.forEach((image) => this.observer.observe(image));
    }
    if (this.links.length) {
      this.links.forEach((link) => this.linkObserver.observe(link));
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.linkObserver.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.style.filter = "blur(0)";
        });
      }
    });
  };

  handleLinkObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.style.transform = "translateX(0)";
        });
      }
    });
  };
}

customElements.define("shop-the-collection", ShopTheCollection);


// COUNTDOWN TIMER
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.rawDate = this.dataset.countdownDate;
    this.endDate = this.parseDate(this.rawDate);
    this.interval = null;

    this.daysEl = this.querySelector(".c_days h2");
    this.hoursEl = this.querySelector(".c_hrs h2");
    this.minsEl = this.querySelector(".c_mins h2");
    this.secsEl = this.querySelector(".c_secs h2");

    this.previousValues = { days: null, hours: null, mins: null, secs: null };
    this.initialRenderDone = false;
  }

  connectedCallback() {
    if (isNaN(this.endDate.getTime())) {
      this.setToZero();
      return;
    }
    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  parseDate(dateStr) {
    if (/^\d{2}-\d{2}-\d{4}/.test(dateStr)) {
      const [datePart, timePart = "00:00:00"] = dateStr.split(" ");
      const [day, month, year] = datePart.split("-");
      return new Date(`${year}-${month}-${day}T${timePart}`);
    }
    return new Date(dateStr);
  }

  startCountdown() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate.getTime() - now;

    if (distance <= 0) {
      this.setToZero();
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.render(days, hours, minutes, seconds);
    this.initialRenderDone = true;
  }

  render(days, hours, minutes, seconds) {
    this.updateElement(this.daysEl, this.pad(days), "days");
    this.updateElement(this.hoursEl, this.pad(hours), "hours");
    this.updateElement(this.minsEl, this.pad(minutes), "mins");
    this.updateElement(this.secsEl, this.pad(seconds), "secs");
  }

  updateElement(el, newValue, key) {
    if (!el) return;

    const shouldAnimate =
      this.initialRenderDone && this.previousValues[key] !== newValue;

    if (shouldAnimate) {
      el.classList.remove("fade");
      void el.offsetWidth; 
      el.textContent = newValue;
      el.classList.add("fade");
    } else {
      el.textContent = newValue;
    }

    this.previousValues[key] = newValue;
  }

  setToZero() {
    this.render(0, 0, 0, 0);
  }

  pad(num) {
    return num < 10 ? "0" + num : num;
  }
}

customElements.define("countdown-timer", CountdownTimer);



// FEATURED MULTI COLUMNS
class FeaturedMultiColumns extends HTMLElement {
  constructor() {
    super();
    this.images = [...this.querySelectorAll(".mc_img_wrapper img")];

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px -300px 0px",
    });
  }

  connectedCallback() {
    if (this.images.length) {
      this.images.forEach((image) => this.observer.observe(image));
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.style.filter = "blur(0)";
        });
      }
    });
  };
}

customElements.define("featured-multi-columns", FeaturedMultiColumns);

// COLLECTION PRODUCT GRID
class CollectionProductGrid extends HTMLElement {
  constructor() {
    super();   

    this.boxes = this.querySelectorAll('.product_card');
    this.heights = [];

    // Debounced functions
    this.debouncedSubmit = debounce(
      (event, loader) => this.handleSubmit(event, loader),
      600
    );
    this.debouncedClick = debounce(
      (href, loader) => this.handleClick(href, loader),
      600
    );
    this.debouncedPriceSubmit = debounce(
      (event, loader) => this.handleSubmit(event, loader),
      1000
    );

    this.debouncedPriceSliderSubmit = debounce(
      (value, nextInput, event, loader) =>
        this.handleSliderSubmit(value, nextInput, event, loader),
      1000
    );
  }

  connectedCallback() {
    this.attachListeners();
    window.addEventListener('load', this.setEqualHeights.bind(this));
    window.addEventListener('resize', this.setEqualHeights.bind(this));
  }

  setEqualHeights() {
    this.boxes.forEach((box) => {
      const h2 = box.querySelector('.product_card_title');
      if(h2) this.heights.push(h2.offsetHeight);
    })

    const maxHeight = Math.max(...this.heights);

    this.boxes.forEach((box) => {
     // box.style.setProperty('--height', `${maxHeight}px`);
      this.style.setProperty('--height', `${maxHeight}px`);
    })
  }

  attachListeners() {
    const loader = this.querySelector(".filter_loader_wrapper");

    const drawerWrapper = this.querySelectorAll(".drawer_filter_icon");
    const drawer = document.querySelector(".mobile_filter_drawer_wrapper");

    if (drawerWrapper && drawer) {
      drawerWrapper.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.openDrawer(drawer, btn);
        });
      });
    }

    this.querySelectorAll(
      ".filter_input, .collection_sorting_wrapper select"
    ).forEach((element) =>
      element.addEventListener("change", (event) => {
        this.debouncedSubmit(event, loader);
        loader.style.display = "flex";
      })
    );

    this.querySelectorAll(".collection_active_filters_wrapper p a").forEach(
      (link) =>
        link.addEventListener("click", (e) => {
          e.preventDefault();
          this.debouncedClick(link.getAttribute("href"), loader);
          loader.style.display = "flex";
        })
    );

    this.querySelectorAll(".filter_price_input").forEach((price_input) =>
      price_input.addEventListener("input", (event) => {
        this.debouncedPriceSubmit(event, loader);
        loader.style.display = "flex";
      })
    );

    this.querySelectorAll(".filter_price_slider").forEach((price_slider) => {
      price_slider.addEventListener("change", (e) => {
        let value = price_slider.value;
        let nextInput = price_slider.nextElementSibling;
        this.debouncedPriceSliderSubmit(value, nextInput, e, loader);
        loader.style.display = "flex";
      });
    });    
  }

  openDrawer(drawer, button) {
    this.closeAllDrawers();

    if (drawer) {
      drawer.classList.add("active");
      drawer.setAttribute("aria-hidden", "false");
      if (drawer.classList.contains("mobile_filter_drawer_wrapper")) {
        document.querySelector(".header-section").style.zIndex = "0";
      }

      document.body.classList.add("overflow-hidden");

      const focusable = drawer.querySelectorAll("button, input, a");
      if (focusable.length) focusable[0].focus();

      drawer.addEventListener("keydown", (e) => trapFocus(e, drawer));
    }
  }

  closeAllDrawers() {
    document.querySelectorAll(".main_drawer").forEach((drawer) => {
      drawer.classList.remove("active");
      drawer.setAttribute("aria-hidden", "true");
    });
    document.body.classList.remove("overflow-hidden");
  }

  async handleSubmit(e, loader) {
    e.preventDefault();
    const form =
      this.querySelector("#sorting_form_with_no_filters") ||
      this.querySelector("#sorting_form_with_filters");
    if (!form) return;

    const formData = new FormData(form);

    const priceGte = form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {
        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams(formData).toString();
    const newURL = `${window.location.pathname}?${params}`;

    history.pushState(null, "", newURL);

    await this.fetchAndUpdate(newURL, loader);
  }

  async handleSliderSubmit(value, nextInput, e, loader) {
    e.preventDefault();
    nextInput.value = value;
    const form =
      this.querySelector("#sorting_form_with_no_filters") ||
      this.querySelector("#sorting_form_with_filters");
    if (!form) return;
    const params = new URLSearchParams(new FormData(form)).toString();
    const newURL = `${window.location.pathname}?${params}`;
    history.pushState(null, "", newURL);

    await this.fetchAndUpdate(newURL, loader);
  }

  async handleClick(href, loader) {
    if (!href) return;
    history.pushState(null, "", href);
    await this.fetchAndUpdate(href, loader);
  }

  async fetchAndUpdate(url, loader) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.text();
      const html = new DOMParser().parseFromString(data, "text/html");
      const updatedContent = html.querySelector("collection-product-grid");
      const updatedDrawer = html.querySelector("mobile-filters");

      if (updatedContent) {
        this.innerHTML = updatedContent.innerHTML;
        this.attachListeners();

        this.heights = [];
        this.boxes = this.querySelectorAll('.product_card');
        this.setEqualHeights();

        if(updatedDrawer) {
          const currentMobileFilters = document.querySelector('mobile-filters');

          if(currentMobileFilters) {
            const newMobileFilters = updatedDrawer.cloneNode(true);
            currentMobileFilters.parentNode.replaceChild(newMobileFilters, currentMobileFilters);

            if (customElements.get('mobile-filters')) {
              const newInstance = document.querySelector("mobile-filters");
              // Manually call connectedCallback to reattach listeners
              if (newInstance.connectedCallback) {
                newInstance.connectedCallback();
              }
            }
          }
        }        

        document.dispatchEvent(new CustomEvent("collectionGridUpdated"));
      }      

    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      loader.style.display = "none";
    }
  }
}

customElements.define("collection-product-grid", CollectionProductGrid);

class PriceFilterRange extends HTMLElement {
  constructor() {
    super();

    this.rangeMin = this.querySelector("input.range-min");
    this.rangeMax = this.querySelector("input.range-max");
    this.inputMin = this.querySelector("input.input-min");
    this.inputMax = this.querySelector("input.input-max");
    this.minValue = this.querySelector(".value-min");
    this.maxValue = this.querySelector(".value-max");

    this.rangeMin.addEventListener("input", this.onInputMinChange.bind(this));
    this.rangeMax.addEventListener("input", this.onInputMaxChange.bind(this));

    this.setProgressMin();
    this.setProgressMax();
  }

  onInputMinChange(event) {
    event.stopPropagation();

    if (parseInt(this.rangeMin.value) >= parseInt(this.rangeMax.value))
      return (this.rangeMin.value = this.rangeMax.value);

    this.inputMin.value = this.rangeMin.value;
    this.setProgressMin();
  }

  onInputMaxChange(event) {
    event.stopPropagation();

    if (parseInt(this.rangeMax.value) <= parseInt(this.rangeMin.value))
      return (this.rangeMax.value = this.rangeMin.value);

    this.inputMax.value = this.rangeMax.value;
    this.setProgressMax();
  }

  setProgressMin() {
    this.minValue.innerText = this.rangeMin.value;
    this.style.setProperty(
      "--x-start",
      `${
        ((this.rangeMin.value - this.rangeMin.min) * 100) /
        (this.rangeMin.max - this.rangeMin.min)
      }%`
    );
  }

  setProgressMax() {
    this.maxValue.innerText = this.rangeMax.value;
    this.style.setProperty(
      "--x-end",
      `${
        ((this.rangeMax.value - this.rangeMin.min) * 100) /
        (this.rangeMin.max - this.rangeMin.min)
      }%`
    );
  }
}

customElements.define("price-filter-range", PriceFilterRange);


// COLLECTION TABS
class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.ct_block_head');
    this.ctWrapper = this.querySelectorAll('.ct_wrapper');
    this.link = this.querySelector('.collection_tabs_head_link a');
    this.sliders = this.querySelectorAll('.collection_tabs_slider');
    this.columns = Number(this.dataset.columns) || 4;
    this.spacing = Number(this.dataset.spacing) || 20;
  }

  connectedCallback() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => this.handleClick(e));
    });

    this.sliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        slidesPerView: this.columns,
        spaceBetween: this.spacing,
        speed: 800,
      });
    });

    this.ctWrapper.forEach((wrapper) => {
      if(wrapper.classList.contains('active')) {} else {
        wrapper.querySelectorAll('input, button, a').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
      }
    })
  }

  handleClick(e) {
    e.preventDefault();
    this.tabs.forEach((t) => t.classList.remove('active'));
    e.currentTarget.classList.add('active');
    const index = e.currentTarget.dataset.index;
    const collectionUrl = e.currentTarget.dataset.collection;

    if (this.link) {
      this.link.setAttribute('href', collectionUrl);
    }

    this.ctWrapper.forEach((wrapper) => {
      const i = wrapper.dataset.index;
      if (index == i) {
        wrapper.classList.add('active');
        wrapper.querySelectorAll('input, button, a').forEach((el) => {
          el.setAttribute('tabindex', '0');
        })
        const slider = wrapper.querySelector('.collection_tabs_slider');
        if (slider?.swiper) slider.swiper.update();
      } else {
        wrapper.querySelectorAll('input, button, a').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        })
        wrapper.classList.remove('active');
      }
    });
  }
}

customElements.define("collection-tabs", CollectionTabs);



// FEATURED BLOG
class FeaturedBlog extends HTMLElement {
  constructor() {
    super();   
    this.swiper = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.initSwiper();
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    if (this.swiper) this.swiper.destroy(true, true);
  }

  initSwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.swiper = new Swiper(`.fbs-${this.getAttribute("section-id")}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 600,
      autoHeight: window.innerWidth < 990,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      on: {
        init: (swiper) => this.updateNavImages(swiper),
        transitionEnd: (swiper) => this.updateNavImages(swiper),
      },
    });
  }

  handleResize() {
    // Optional: Debounce for performance
    clearTimeout(this._resizeTimeout);
    this._resizeTimeout = setTimeout(() => {
      this.initSwiper();
    }, 300);
  }

  updateNavImages(swiperInstance) {
    const nextSlide = swiperInstance.slides[swiperInstance.realIndex + 1];
    const prevSlide =
      swiperInstance.slides[swiperInstance.realIndex - 1] ||
      swiperInstance.slides[swiperInstance.slides.length - 1];
    const prevDiv = document.querySelector(".fb_before");
    const nextDiv = document.querySelector(".fb_after");
    const prevBtn = swiperInstance.navigation.prevEl;
    const nextBtn = swiperInstance.navigation.nextEl;

    prevDiv.classList.toggle(
      "dim",
      prevBtn.classList.contains("swiper-button-disabled")
    );
    nextDiv.classList.toggle(
      "dim",
      nextBtn.classList.contains("swiper-button-disabled")
    );

    if (nextSlide) {
      const nextImage = nextSlide.querySelector(
        ".featured_article_img img"
      )?.src;
      const nextDivImage = nextDiv.querySelector("img");
      const nextButtonImage = this.querySelector(".swiper-button-next img");
      this.fadeImage(nextButtonImage, nextImage, nextDivImage);
    }

    if (prevSlide) {
      const prevImage = prevSlide.querySelector(
        ".featured_article_img img"
      )?.src;
      const prevDivImage = prevDiv.querySelector("img");
      const prevButtonImage = this.querySelector(".swiper-button-prev img");
      this.fadeImage(prevButtonImage, prevImage, prevDivImage);
    }
  }

  fadeImage(imageElement, newSrc, divElement) {
    if (!newSrc || !imageElement || !divElement) return;
    imageElement.style.opacity = "0";
    setTimeout(() => {
      imageElement.src = newSrc;
      divElement.src = newSrc;
      imageElement.style.opacity = "1";
    }, 300);
  }
}

customElements.define("featured-blog", FeaturedBlog);


function isMobile() {
  return window.matchMedia("(max-width: 749px)").matches;
}

document.addEventListener("DOMContentLoaded", function () {
  initializeScroll();
});

function initializeScroll() {
  if (
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    isMobile()
  )
    return;
  const animationTriggerElements = Array.from(
    document.querySelectorAll(
      ".scroll-synergy:not([data-scroll-synergy-observed])"
    )
  );
  if (animationTriggerElements.length === 0) return;
  const observer = new IntersectionObserver((elements) => {
    elements.forEach((entry) => {
      let prePosition;
      const handleScroll = throttle(() => {
        const percentage = percentageSeen(entry.target);
        let position = 0;
        if (
          (percentage <= 0
            ? (position = 0)
            : percentage < 30
            ? (position = 1)
            : percentage < 100
            ? (position = 2)
            : (position = 3),
          prePosition !== position &&
            (entry.target.classList.remove(
              "synergy-position--1",
              "synergy-position--2"
            ),
            position > 0 &&
              position < 3 &&
              entry.target.classList.add(`synergy-position--${position}`),
            (prePosition = position)),
          entry.target.style.setProperty("--synergy-ratio", `${percentage}%`),
          entry.target.classList.contains("synergy--zoom-in"))
        ) {
          const zoomInRatio = 1 + 0.005 * percentage;
          entry.target.style.setProperty(
            "--zoom-in-ratio",
            zoomInRatio.toString()
          );
        } else if (entry.target.classList.contains("synergy--parallax")) {
          const parallaxRatio = percentage / 100;
          entry.target.style.setProperty(
            "--parallax-ratio",
            parallaxRatio.toString()
          );
        } else if (
          entry.target.classList.contains("synergy--crab-left") ||
          entry.target.classList.contains("synergy--crab-right")
        ) {
          let crabRatio = 0.25 * percentage;
          entry.target.classList.contains("synergy--crab-left") &&
            (crabRatio = -1 * crabRatio),
            entry.target.style.setProperty("--crab-ratio", `${crabRatio}%`);
        }
      });
      entry.isIntersecting
        ? window.addEventListener("scroll", handleScroll)
        : window.removeEventListener("scroll", handleScroll);
    });
  });
  animationTriggerElements.forEach((element) => {
    observer.observe(element),
      element.setAttribute("data-scroll-synergy-observed", "true");
  });
}

// SCROLL-LIST
class ScrollList extends HTMLElement {
  constructor() {
    super(),
      (this.listContainer = this.querySelector(".scroll_list")),
      (this.scrollDirection = this.getAttribute("data-direction") || "left"),
      (this.speed = parseInt(this.getAttribute("data-speed")) || 40),
      (this.currentTrans = 0),
      (this.lastWindowWidth = window.innerWidth),
      this.observeInView(),
      (window.Shopify.designMode || window.debug) &&
        ((this.debounceWindowSizeChangeHandler = debounce(
          this.onWindowSizeChange.bind(this),
          500
        )),
        window.addEventListener(
          "resize",
          this.debounceWindowSizeChangeHandler
        ));
  }

  disconnectedCallback() {
    this.debounceWindowSizeChangeHandler &&
      window.removeEventListener(
        "resize",
        this.debounceWindowSizeChangeHandler
      );
  }

  connectedCallback() {
    let images = this.querySelectorAll("img");
    let wrapper = this.closest(".scroll_list_wrapper");
    let height = wrapper.getBoundingClientRect().height;
    wrapper.parentElement.style.setProperty("--height", `${height}px`);
  }

  init() {
    if ((this.getAllItems(), this.items.length < 1)) return;

    this.getOriginalTotalWidth(),
      this.cloneItems(),
      this.getAllItems(),
      this.getGap();

    const transformDistance = this.originalWidth + this.gap;

    if (this.scrollDirection === "right") {
      this.style.setProperty("--from-x", "0");
      this.style.setProperty("--end-x", `-${transformDistance}px`);
    } else {
      this.style.setProperty("--from-x", `-${transformDistance}px`);
      this.style.setProperty("--end-x", "0");
    }

    this.setAttribute("data-init", "true");
  }

  onWindowSizeChange() {
    const currentWidth = window.innerWidth;
    currentWidth !== this.lastWindowWidth &&
      ((this.lastWindowWidth = currentWidth),
      this.hasAttribute("data-init") &&
        (this.removeAttribute("data-init"),
        setTimeout(() => {
          this.classList.add("hidden"),
            this.querySelectorAll(".item-clone").forEach((item) =>
              item.remove()
            ),
            this.classList.remove("hidden"),
            this.init();
        })));
  }

  observeInView() {
    new IntersectionObserver(
      (entries, observer2) => {
        entries[0].isIntersecting && (this.init(), observer2.disconnect());
      },
      {
        root: null,
        rootMargin: "100px 0px 100px 0px",
      }
    ).observe(this);
  }

  cloneItems() {
    const times = Math.ceil(this.clientWidth / this.originalWidth);
    let fragment = document.createDocumentFragment();
    for (let i = 0; i < times; i++)
      this.items.forEach((item) => {
        const cloneItem = item.cloneNode(!0);
        cloneItem.removeAttribute("data-shopify-editor-block"),
          cloneItem.classList.add("item-clone"),
          fragment.appendChild(cloneItem);
      });
    this.listContainer.appendChild(fragment);
  }
  getAllItems() {
    this.items = Array.from(this.querySelectorAll(".scroll_list_item"));
  }
  getOriginalTotalWidth() {
    this.originalWidth =
      this.items[this.items.length - 1].offsetLeft -
      this.items[0].offsetLeft +
      this.items[this.items.length - 1].offsetWidth;
  }
  getGap() {
    this.items.length < 2
      ? (this.gap = 32)
      : (this.gap =
          this.items[1].offsetLeft -
          this.items[0].offsetLeft -
          this.items[0].offsetWidth);
  }
  moveItemVisible(item) {
    if (this.items.indexOf(item) === -1) return;
    const containerRect = this.getBoundingClientRect(),
      itemRect = item.getBoundingClientRect();
    let offset;
    if (itemRect.right > containerRect.right)
      offset = containerRect.right - itemRect.right;
    else if (itemRect.left < containerRect.left)
      offset = containerRect.left - itemRect.left;
    else return;
    (this.currentTrans = this.currentTrans + offset),
      (this.listContainer.style.transform = `translateX(${this.currentTrans}px)`);
  }
}

customElements.define("scroll-list", ScrollList);

// DRAWER OPEN/CLOSE
const openBtns = document.querySelectorAll(".drawer_open_btn");
const closeBtns = document.querySelectorAll(".drawer_close_btn");
const drawers = document.querySelectorAll(".main_drawer");

let lastFocusedButton = null;

drawers.forEach((drawer) => {
  const focusableElements = drawer.querySelectorAll("button, input, a");
  focusableElements.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });
});

function closeAllDrawers() {
  drawers.forEach((drawer) => {
    drawer.classList.remove("active");
    drawer.setAttribute("aria-hidden", "true");
  });
}

function trapFocus(event, drawer) {
  const focusableElements = drawer.querySelectorAll("button:not([tabindex='-1']), input:not([tabindex='-1']), a:not([tabindex='-1'])");
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

function openDrawer(drawer, button) {
  closeAllDrawers();
  if (drawer) {
    lastFocusedButton = button;

    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");
    lenis.stop();

    const focusableElements = drawer.querySelectorAll("button, input, a");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "0");
    });

    if (focusableElements.length) {
      focusableElements[0].focus();
    }

    drawer.addEventListener("keydown", (event) => trapFocus(event, drawer));
  }
}

function closeDrawer(drawer) {
  if (drawer) {
    drawer.classList.remove("active");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");
    if (drawer.classList.contains("mobile_filter_drawer_wrapper")) {
      setTimeout(() => {
        document.querySelector(".header-section").style.zIndex = "4";
      }, 200);
    } else if(drawer.classList.contains('quick_add_drawer_wrapper')) {
     const placeholderTemplate = document.getElementById('quick_add_drawer_placeholder_template');
     const contentWrapper = drawer.querySelector('.quick_add_drawer_main_inner');

      if (placeholderTemplate && contentWrapper) {
        contentWrapper.innerHTML = placeholderTemplate.innerHTML;
      }
    }

    const focusableElements = drawer.querySelectorAll("input, button, a");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "-1");
    });

    lenis.start();

    if (lastFocusedButton) {
      lastFocusedButton.focus();
      lastFocusedButton = null;
    }
  }
}

openBtns.forEach((button) => {
  button.addEventListener("click", async (event) => {
    event.preventDefault();
    const drawerId = button.getAttribute("data-drawer");
    const drawer = document.getElementById(drawerId);
    openDrawer(drawer, button);
  });
});

closeBtns.forEach((button) => {
  button.addEventListener("click", () => {
    const drawer = button.closest(".main_drawer");
    closeDrawer(drawer);
  });
});

drawers.forEach((drawer) => {
  drawer.addEventListener("click", (event) => {
    if (event.target === drawer) {
      closeDrawer(drawer);
    }
  });

  drawer.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer(drawer);
    }
  });
});

document.querySelectorAll("img").forEach((img) => {
  img.addEventListener("load", function () {
    this.classList.add("loaded");
  });
});

// SCROLL TO TOP
document.addEventListener("DOMContentLoaded", () => {
  const scrollTop = document.querySelector(".scroll_to_top_wrapper");

  if (!scrollTop) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 200) {
      scrollTop.classList.add("visible");
    } else {
      scrollTop.classList.remove("visible");
    }
  });

  scrollTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});

// MAIN CART NOTE
if (!customElements.get("main-cart-note")) {
  customElements.define(
    "main-cart-note",
    class MainCartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent("note-update:user-action", event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// CART ITEM REMOVE
class CartRemove extends HTMLElement {
  constructor() {
    super();
    const removeLink = this.querySelector("a");
    removeLink.addEventListener("click", (e) => {
      let line = removeLink.getAttribute("data-line");
      let loader = removeLink.previousElementSibling;
      let qty = 0;
      e.preventDefault();
      loader.classList.remove("hidden");
      removeLink.classList.add("hidden");
      const mainCart =
        this.closest("main-cart-page") || this.closest("cart-drawer");
      mainCart.updateQty(line, qty, loader, removeLink);
    });
  }
}
customElements.define("cart-remove", CartRemove);

// CART MAIN PAGE
class MainCartPage extends HTMLElement {
  constructor() {
    super();

    const debouncedOnChange = debounce(
      this.onChange.bind(this),
      ON_CHANGE_DEBOUNCE_TIMER
    );
    this.addEventListener("change", debouncedOnChange);
  }

  connectedCallback() {
    this.totalPrice = this.dataset.total;
    const shippingBar = this.querySelector('.cc_free_shipping_bar_wrapper');
    if(shippingBar) {
      this.threshold = this.dataset.threshold;
      this.shippingBarUpdate(this.totalPrice);
    }
  }

   shippingBarUpdate(totalPrice = 0) {
    const currency = Shopify.currency?.active || '{{ cart.currency.iso_code }}';

    const rate = Shopify.currency?.rate || 1;
    const final = Math.round(this.threshold * rate * 100) / 100;
    const convertedTotal = totalPrice

    const remaining = (final * 100) - convertedTotal;
    const percentage = Math.min(Math.round((convertedTotal / (final * 100)) * 100), 100);

    function formatMoney(cents, currency = 'USD') {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2
      }).format(cents / 100);
    }

    const bar = this.querySelector('.cc_shipping_progress_bar_inner')
    if(bar) {
      bar.style.setProperty('--width', `${percentage}%`)
    }

    const message = this.querySelector('.cc_shipping_bar_text p');
    if(!message) return;
    if(remaining > 0) {
      message.textContent = `Spend ${formatMoney(remaining, currency)} more to reach FREE SHIPPING.`
    } else {
      message.textContent = 'You are eligible for FREE SHIPPING!!'
    }

  }

  onChange(event) {
    this.validateQuantity(event);
  }

  validateQuantity(event) {
    const input = event.target;
    const inputValue = parseInt(input.value);
    const index = input.dataset.line;

    const wrapper = input.closest(
      ".cart_item_cart_qty_wrapper"
    )?.nextElementSibling;
    const loader = wrapper?.querySelector(".loader");
    const priceElement = wrapper?.querySelector(".cart_item_total_final_price");

    loader?.classList.remove("hidden");
    priceElement?.classList.add("hidden");

    const message = "";

    if (message) {
      this.setValidity(event, index, message);
    } else {
      input.setCustomValidity("");
      input.reportValidity();
      this.updateQty(index, inputValue, loader, priceElement);
    }
  }

  async updateQty(line, quantity, loader = null, priceElement = null) {
    const formData = { line, quantity };

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const responseText = await response.text();

      if (!response.ok) {
        const errorData = JSON.parse(responseText);
        const cartData = await fetch("/cart.js").then((res) => res.json());
        this.updateCartPage(cartData, cartData.item_count, line, errorData.description);
        return;
      }

      const parsedData = JSON.parse(responseText);
      this.updateCartPage(parsedData, parsedData.item_count);
    } catch (error) {
      console.error("Qty update failed:", error);
    }
  }

  async updateCartPage(cart = null, count, line = null, message = null) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}?section_id=main-cart-page`
      );
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newSection = doc.querySelector("main-cart-page");

      const currentSection = document.querySelector("main-cart-page");
      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;

        currentSection.shippingBarUpdate(cart.total_price)

        if (line && message) {
          const errorWrapper = document
            .querySelector(`[data-index="${line}"]`)
            ?.closest("qty-input")?.nextElementSibling;
          if (errorWrapper) {
            errorWrapper.innerHTML = `<span class="cart_error">${message}</span>`;
          }
        }
      }

      this.updateCartBubble(count);
    } catch (err) {
      console.error("Error updating cart section:", err);
    }
  }

  updateCartBubble(count) {
    const bubble = document.querySelector("#cart-icon-bubble .cc_text");
    const bubbleHidden = document.querySelector(
      "#cart-icon-bubble .visually-hidden"
    );

    if (bubble) bubble.textContent = `(${count})`;
    if (bubbleHidden) bubbleHidden.textContent = `${count} items`;
  }
}

customElements.define("main-cart-page", MainCartPage);

// RECOMMENDED PRODUCTS
class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;
    this.spacing = this.dataset.spacing;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobColumns;

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px 300px 0px",
    });
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect(); // Prevents memory leaks
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.disconnect(); // Stop observing after load
        requestAnimationFrame(() => {
          this.loadRecommendedProducts(
            this.recommendedURL,
            this.productId,
            this.sectionId
          );
        });
      }
    });
  };

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;
        const recommendedProducts = html.querySelector("recommended-products");

        if (recommendedProducts?.innerHTML.trim().length) {
          this.innerHTML = recommendedProducts.innerHTML;

          this.productsInner =
            this.querySelector(".product_recommendations_inner") ||
            this.querySelector(".complementary_products_inner");

          this.initRecommendedSlider(
            this.productsInner,
            this.spacing,
            this.columns,
            this.mobColumns
          );

          document.dispatchEvent(new CustomEvent("RecommendedProductsUpdated"));
                    
        }
      });
  }

  initRecommendedSlider(inner, spacing, columns, mobColumns) {
    new Swiper(inner, {
      slidesPerView: columns,
      spaceBetween: spacing,
      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next')
      },
      breakpoints: {
        0: {
          slidesPerView: mobColumns,
          spaceBetween: 15,
        },       
        640: {
          slidesPerView: 3,
          spaceBetween: spacing,
        },
        1024: {
          slidesPerView: columns,
          spaceBetween: spacing,
        },
        1399: {
          slidesPerView: columns,
          spaceBetween: spacing,
        },
      },
    });
  }
}

customElements.define("recommended-products", RecommendedProducts);

// MEDIA GALLERY
class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.handleResize = this.handleResize.bind(this);

    this.videos = [
      ...this.querySelectorAll(".main_media_slider_wrapper video"),
      ...this.querySelectorAll(".media_thumbnails_inner video"),
    ];

    this.models = [
      ...this.querySelectorAll(".main_media_slider_wrapper product-model"),
      ...this.querySelectorAll(".media_thumbnails_inner product-model"),
    ];

    this.yts = [
      ...this.querySelectorAll(".main_media_slider_wrapper .js-youtube"),
      ...this.querySelectorAll(".media_thumbnails_inner .js-youtube"),
    ];

    this.vms = [
      ...this.querySelectorAll(".main_media_slider_wrapper .js-vimeo"),
      ...this.querySelectorAll(".media_thumbnails_inner .js-vimeo"),
    ];

    this.mainSliderWrapper = this.querySelector(".main_media_slider_wrapper");
    this.thumbnailSliderWrapper = this.querySelector(
      ".thumbnail_media_slider_wrapper"
    );
    this.spacing = this.dataset.spacing;
    this.direction = this.dataset.direction;

    this.models.forEach((model) => {
      model.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.playProductModel(model);
      });
    });

    this.yts.forEach((yt) => {
      const ytOverlay = yt.previousElementSibling;
      ytOverlay.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.playYouTubeVideo(yt, ytOverlay);
      });
    });


    this.vms.forEach((vm) => {
      const vmOverlay = vm.previousElementSibling;
      vmOverlay.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.playVimeoVideo(vm, vmOverlay);
      });
    });

    this.videos.forEach((video) => {
      const overlay = video.previousElementSibling;
      const btn = video.nextElementSibling;

      if (overlay) {
        overlay.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.playVideo(video, btn);
        });
      }

      if (btn) {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.playVideo(video, btn);
        });
      }

      video.addEventListener("pause", () => {
        video.classList.remove("playing");
        if (btn) btn.style.display = "flex";
        if (overlay) overlay.style.display = "block";
      });

      video.addEventListener("play", () => {
        video.classList.add("playing");
        if (btn) btn.style.display = "none";
        if (overlay) overlay.style.display = "none";
      });
    });

    this.initSwiper();

    this.addEventListener("variant-media-change", (e) => {
      const mediaId = e.detail.mediaId;
      if (!mediaId || !this.swiperInstance) return;

      const slides = Array.from(this.querySelectorAll(".swiper-slide"));
      const targetIndex = slides.findIndex((slide) =>
        slide.querySelector(`[data-media-id*="${mediaId}"]`)
      );

      if (targetIndex !== -1) {
        this.swiperInstance.slideTo(targetIndex);
      }
    });

    if (
      this.classList.contains("thumbnail-left") ||
      this.classList.contains("thumbnail-right")
    ) {
      this.matchThumbnailHeight();
      window.addEventListener("resize", () => this.matchThumbnailHeight());
    }

    if (
      this.classList.contains("thumbnail-left") ||
      this.classList.contains("thumbnail-right")
    ) {
      this.handleResize = this.handleResize.bind(this);
    }
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
    if (this.thumbnailSwiperInstance) {
      this.thumbnailSwiperInstance.destroy(true, true);
    }
    window.removeEventListener("resize", this.handleResize);
  }

  playProductModel(model) {
    this.pauseAllMedia();
    const icon = model.querySelector(".main_icon_wrapper");
    if (icon) {
      if (icon.classList.contains("not_visible")) {
        icon.classList.remove("not_visible");
        icon.style.display = "none";
      } else {
        icon.classList.add("not_visible");
        icon.style.display = "flex";
      }
    }

    if (model.modelViewerUI) {
      model.modelViewerUI.play();
    } else {
      const viewer = model.querySelector("model-viewer");
      if (viewer) viewer.play();
    }
  }

  playYouTubeVideo(iframe, overlay) {
      overlay.style.display = 'none';
      console.log(iframe)

      this.pauseAllMedia(iframe);
      iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
        "*"
        );      
  }

  playVimeoVideo(iframe, overlay) {    
    this.pauseAllMedia();
    overlay.style.display = "none";   
      iframe.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  playVideo(video, btn) {
    this.pauseAllMedia();
    video.play();
  }

  matchThumbnailHeight() {
    if (!this.mainSliderWrapper || !this.thumbnailSliderWrapper) return;

    const mainHeight = this.mainSliderWrapper.offsetHeight;
    this.thumbnailSliderWrapper.style.height = `${mainHeight}px`;
  }

  pauseAllMedia(except = null) {
    document.querySelectorAll(".js-youtube").forEach((video) => {
      const ol = video.previousElementSibling;
      if(!ol) return;
      if(video !== except) {
        ol.style.display = 'block'  
      }

      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });

    document.querySelectorAll(".js-vimeo").forEach((video) => {
      const ol = video.previousElementSibling;
      if (video !== except) {
        ol.style.display = 'block';
      }
      
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    document.querySelectorAll("video").forEach((video) => video.pause());

    document.querySelectorAll("product-model").forEach((model) => {
      const icon = model.querySelector(".main_icon_wrapper");
      if (icon) {
        icon.style.display = "flex";
        icon.classList.add("not_visible");
      }

      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  getSwiperDirection() {
    const width = window.innerWidth;
    if (width < 989) return "horizontal";
    return this.direction || "vertical";
  }

  handleResize() {
    const newDirection = this.getSwiperDirection();
    if(!this.thumbnailSwiperInstance) return;
    if (this.thumbnailSwiperInstance?.params?.direction !== newDirection) {
      this.thumbnailSwiperInstance.changeDirection(newDirection, false);
      this.thumbnailSwiperInstance.update();
    }

    requestAnimationFrame(() => {
      setTimeout(() => this.matchThumbnailHeight(), 100); // 100ms is usually enough
    });
  }

  initSwiper() {
    if (typeof Swiper === "undefined") {
      console.warn(
        "Swiper is not defined. Did you forget to include the library?"
      );
      return;
    }

    if(this.thumbnailSliderWrapper) {    
      this.thumbnailSwiperInstance = new Swiper(this.thumbnailSliderWrapper, {
        loop: false,
        speed: 600,
        slidesPerView: 5,
        spaceBetween: this.spacing,
        watchSlidesProgress: true,
        direction: this.getSwiperDirection(),
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 5,
            spaceBetween: 15,
            direction: "horizontal",
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 15,
            direction: "horizontal",
          },
          989: {
            slidesPerView: 5,
            spaceBetween: 15,
          },
          1299: {
            slidesPerView: 5,
            spaceBetween: 15,
          },
        },
      });
    }

    this.swiperInstance = new Swiper(this.mainSliderWrapper, {
      loop: false,
      speed: 600,
      slidesPerView: 1,
      spaceBetween: this.spacing,
      touchRatio: 0,
      thumbs: {
        swiper: this.thumbnailSwiperInstance,
      },
      on: {
        slideChange: () => {
          //this.pauseAllMedia();
          // this.videos.forEach((video) => {
          //   if (!video.paused) {
          //     video.pause();
          //   }
          // });
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 15,
          direction: "horizontal",
          touchRatio: 1,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: this.spacing,
          direction: "horizontal",
        },
        768: {
          slidesPerView: 1,
          spaceBetween: this.spacing,
          direction: "horizontal",
        },
        989: {
          slidesPerView: 1,
          spaceBetween: this.spacing,
        },
      },
    });
  }
}

customElements.define("media-gallery", MediaGallery);

// MAIN BLOG PAGE
class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.blogHandle = this.dataset.blog;
    this.loader = this.querySelector(".loader_wrapper");
    this.isFetching = false;
    this.initComponent();
  }
  
  handleGrid() {
    this.cards.forEach((card, index) => {
      const i = index + 1;
      card.classList.remove("two_cols", "three_cols"); // reset
      card.classList.add(i >= 3 && (i - 3) % 5 < 3 ? "three_cols" : "two_cols");
    });
  }

  bindTagEvents() {
    this.tags?.forEach((tag) => {
      tag.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.isFetching) return;
        this.loader?.classList.remove("hidden");
        const tagParent = tag.closest(".main_blog_tags");
        this.handleTagsClick(tagParent, tag.dataset.tag);
      });
    });
  }

  updateCountText(newCount, newCountAll, useAllCount = false) {
    const countWrapper = this.previousElementSibling?.querySelector(
      ".main_blog_count span"
    );

    const countToUse = useAllCount ? newCountAll : newCount;

    if (countWrapper && countToUse !== undefined) {
      countWrapper.textContent =
        countToUse == "1"
          ? `${countToUse} article found`
          : `${countToUse} articles found`;
    }
  }

  handleTagsClick(t = null, tag) {
    if (this.isFetching) return;
    this.isFetching = true;

    document.querySelectorAll(".main_blog_tags").forEach((main_blog_tag) => {
      main_blog_tag.classList.remove("active");
    });
    t.classList.add("active");

    const isAll = tag === "all" || !tag;
    const url = isAll
      ? `/blogs/${this.blogHandle}`
      : `/blogs/${this.blogHandle}/tagged/${tag}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const updatedBlog = doc.querySelector("main-blog");

        if (updatedBlog) {
          const newInner = updatedBlog.querySelector(".main_blog_inner");
          const currentInner = this.querySelector(".main_blog_inner");

          if (newInner && currentInner) {
            currentInner.replaceWith(newInner);
          }

          const newCount = newInner?.dataset.count;
          const newCountAll = newInner?.dataset.countAll;

          this.updateCountText(newCount, newCountAll, isAll);

          // Reinitialize content
          this.initComponent();
          this.observeCards();
        }
      })
      .catch((err) => console.error("Failed to load filtered blog:", err))
      .finally(() => {
        this.loader?.classList.add("hidden");
        this.isFetching = false;
      });
  }

  initComponent() {
    this.cards = [...this.querySelectorAll(".main_blog_article_wrapper")];
    this.tags = [
      ...(this.previousElementSibling?.querySelectorAll(".main_blog_tags a") ||
        []),
    ];
    this.count = this.querySelector(".main_blog_inner")?.dataset.count;

    this.handleGrid();
    this.bindTagEvents();
  }
}

customElements.define("main-blog", MainBlog);

// MAIN CUSTOMER FORM
class MainCustomerLogin extends HTMLElement {
  constructor() {
    super();
    this.loginForm = this.querySelector(".main_customer_login_wrapper");
    this.recoverForm = this.querySelector(".main_customer_recover_wrapper");

    this.toggleForms = this.toggleForms.bind(this);

    this.toggleForms();

    window.addEventListener("hashchange", this.toggleForms);
  }

  toggleForms() {
    const hash = window.location.hash;

    if (hash === "#recover") {
      this.recoverForm.hidden = false;
      this.loginForm.hidden = true;
    } else {
      this.recoverForm.hidden = true;
      this.loginForm.hidden = false;
    }
  }
}

customElements.define("main-customer-login", MainCustomerLogin);

// PASSWORD EYE
document.addEventListener("DOMContentLoaded", () => {
  const eyeWrappers = document.querySelectorAll(".password_eye");
  if (!eyeWrappers) return;
  eyeWrappers.forEach((eyeWrapper) => {
    const passwordInput = eyeWrapper.closest(".form_input").querySelector("input");
    const closedEye = eyeWrapper.querySelector(".closed_eye");
    const openEye = eyeWrapper.querySelector(".open_eye");

    eyeWrapper.addEventListener("click", () => {
      const isPassword = passwordInput.type === "password";

      passwordInput.type = isPassword ? "text" : "password";
      closedEye.hidden = isPassword;
      openEye.hidden = !isPassword;
    });
  });
});

// KEYBOARD FOCUS CSS
let tabPressed = false;

window.addEventListener("keydown", (e) => {
  if (e.key === "Tab") {
    tabPressed = true;
  }
});

window.addEventListener("mousedown", () => {
  tabPressed = false;
});

document.querySelectorAll(".fi input, .fi textarea").forEach((input) => {
  input.addEventListener("focus", () => {
    if (tabPressed) {
      input.classList.add("keyboard_focus");
    }
  });

  input.addEventListener("blur", () => {
    input.classList.remove("keyboard_focus");
  });
});

// MAIN PASSWORD PAGE MODAL
class MainPasswordPage extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(".modal__close-button");
    this.wrapper = this.querySelector(".password_modal");
    this.closeBtn.addEventListener("click", (e) => {
      this.handleClick();
    });

    if (this.querySelector('input[aria-invalid="true"]')) {
      this.wrapper.setAttribute("open", "open");
    }
  }

  handleClick() {
    this.wrapper.removeAttribute("open");
  }
}

customElements.define("main-password-page", MainPasswordPage);

// MAIN SEARCH PAGE
class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector(".main_search_input");
    this.resetBtn = this.querySelector(".reset_btn");

    this.resetBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.resetForm();
    });

    this.input.addEventListener("input", () => {
      this.toggleResetButton();
    });
  }

  resetForm() {
    this.input.value = "";
    this.toggleResetButton();
  }

  toggleResetButton() {
    if (this.input.value === "") {
      this.resetBtn.classList.add("hidden");
    } else {
      this.resetBtn.classList.remove("hidden");
    }
  }
}

customElements.define("main-search", MainSearch);

// DRAWER FILTERS
class MobileFilters extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector(".filter_loader_wrapper");
    this.collectionGrid = document.querySelector("collection-product-grid");
    this.applyBtn = this.querySelector(".apply_btn");
    this.form = this.querySelector("form.mobile_filter_drawer_form");
    this.drawer = document.querySelector('.mobile_filter_drawer_wrapper');
  }

  connectedCallback() {
    this.attachListeners();    
  }

  attachListeners() {
    if (!this.applyBtn) return;

    this.applyBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (!this.form || !this.loader || !this.collectionGrid) return;

      this.loader.style.display = "block";
      this.handleSubmit();
    });
  }

  async handleSubmit() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    // Create new URLSearchParams
    const newParams = new URLSearchParams();

    // First, preserve non-filter parameters from CURRENT URL (excluding sort_by if it exists in form)
    const currentParams = new URLSearchParams(window.location.search);
    const formHasSortBy = formData.has('sort_by');
    
    for (const [key, value] of currentParams.entries()) {
      // Only preserve parameters that are NOT filter-related
      // AND if form has sort_by, don't preserve the current URL's sort_by
      if (!key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if (key === 'sort_by' && formHasSortBy) {
          continue; // Skip current URL's sort_by if form has its own
        }
        newParams.append(key, value);
      }
    }

    // Then add all active filters and form parameters
    for (const [key, value] of formData.entries()) {
      if (value && value !== "") {
        // For sort_by, use set instead of append to ensure only one value
        if (key === 'sort_by') {
          newParams.set(key, value);
        } else {
          newParams.append(key, value);
        }
      }
    }

    const newURL = `${window.location.pathname}?${newParams.toString()}`;
    
    history.pushState(null, "", newURL);
    await this.fetchAndUpdate(newURL);
  }


  async fetchAndUpdate(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch filtered products");

      const html = new DOMParser().parseFromString(
        await response.text(),
        "text/html"
      );
      const updatedContent = html.querySelector("collection-product-grid");

      if (updatedContent && this.collectionGrid) {
        this.collectionGrid.innerHTML = updatedContent.innerHTML;

        const newInstance = document.querySelector("collection-product-grid");
        newInstance?.attachListeners?.();
        newInstance?.reinitializeObserver?.();

        document.dispatchEvent(new CustomEvent("collectionGridUpdated"));
      }

      const updatedForm = html.querySelector('form.mobile_filter_drawer_form');
      if(updatedForm && this.form) {
        const formParent = this.form.parentElement;

        formParent.replaceChild(updatedForm, this.form);

        this.form = formParent.querySelector('form.mobile_filter_drawer_form');
        
        const btn = formParent.querySelector('.apply_btn');

        if (!btn) return;

        btn.addEventListener("click", (e) => {
          e.preventDefault();
          if (!this.form || !this.loader || !this.collectionGrid) return;

          this.loader.style.display = "block";
          this.handleSubmit();
        });
        
      }

    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      if (this.loader) this.loader.style.display = "none";
      if(this.drawer) closeDrawer(this.drawer);
    }
  }
}

customElements.define("mobile-filters", MobileFilters);

// QUICK ADD
function initializeQuickAddButtons() {
  const quickAddBtns = document.querySelectorAll(".quick_add_btn");

  if (!quickAddBtns.length) return;

  const drawer = document.querySelector(".quick_add_drawer_wrapper");
  const drawerContent = drawer?.querySelector(".quick_add_drawer_main_inner");
  const emptyDiv = drawerContent?.querySelector('.quick_add_empty_img_wrapper');

  if (!drawer || !drawerContent) {
    console.warn(
      "Drawer elements (drawer, content, close button, or loader) missing."
    );
    return;
  }

  quickAddBtns.forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const url = btn.dataset.productUrl;
      if (!url) {
        console.warn("No product URL found on button.");
        return;
      }
      
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const updatedSection = doc.querySelector(".main_product_info");

        if (!updatedSection) {
          console.warn(".main_product_info not found in fetched HTML.");
          return;
        }

        const productInfo = updatedSection.querySelector("product-info");

        productInfo.setAttribute("data-update-url", "false");

        const pickup = updatedSection.querySelector(
          ".pickup_availability_wrapper"
        );
        const relatedProducts = updatedSection.querySelector(
          "recommended-products"
        );
        const collapsibleTabs = updatedSection.querySelectorAll(
          ".collapsible_tab_wrapper"
        );

        if (pickup) pickup.style.display = "none";
        if (relatedProducts) relatedProducts.style.display = "none";
        collapsibleTabs.forEach((tab) => (tab.style.display = "none"));      

        drawerContent.innerHTML = "";        
        
        drawerContent.innerHTML = updatedSection.innerHTML;

        const event = new CustomEvent("product-info:loaded", {
          detail: {
            target: productInfo,
          },
        });
        document.dispatchEvent(event);
      } catch (error) {
        drawerContent.innerHTML = `<p class="error-message">Something went wrong. Please try again.</p>`;
        console.error("Failed to load product info:", error);
      } finally {
        openDrawer(drawer, btn);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeQuickAddButtons();
});

document.addEventListener("collectionGridUpdated", () => {
  initializeQuickAddButtons();
});

document.addEventListener("RecommendedProductsUpdated", () => {
  initializeQuickAddButtons();
});


// RECIPIENT FORM
if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.wrapper = this.querySelector('.recipient_fields_wrapper');
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.recipient_form_error_msg_wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
          this.wrapper.classList.add('visible');
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.wrapper.classList.remove('visible');          
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
          const errorMsgs = document.querySelectorAll('.error_message_wrapper');
          errorMsgs.forEach((msg) => {
            msg.style.display = 'none';
          })
            // document.querySelector('.error_message_wrapper').style.display = 'none';            
        
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}


// VARIANT PICKER
class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      target.querySelectorAll("option").forEach((opt) => {
        opt.removeAttribute("selected");
      });
      target.selectedOptions[0].setAttribute("selected", "selected");
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product_options_wrapper`)
        .querySelector(".product_option_title_value");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-picker", VariantPicker);

// SUB COLLECTIONS
class SubCollections extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelectorAll(".sub_collection_block");
    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px -300px 0px",
    });

    this.columns = parseInt(this.dataset.columns) || 2;
    this.spacing = parseInt(this.dataset.spacing) || 20;
  }

  connectedCallback() {
    this.images.forEach((image) => this.observer.observe(image));
    this.wrapper = this.querySelector(".sub_collections_inner.swiper");
    this.swiperWrapper = this.wrapper?.querySelector(".swiper-wrapper");

    this.initSlider();
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.style.filter = "blur(0)";
        });
      }
    });
  };

  initSlider() {
    if (!this.wrapper) {
      console.warn("Swiper wrapper not found:", this.wrapper);
      return;
    }

    const swiper = new Swiper(this.wrapper, {
      slidesPerView: this.columns,
      spaceBetween: this.spacing,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: this.spacing,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },
        1099: {
          slidesPerView: 3,
          spaceBetween: this.spacing,
        },
        1399: {
          slidesPerView: this.columns,
          spaceBetween: this.spacing,
        },
      },
      on: {
        init: () => {
          this.wrapper.classList.remove("invisible");
          this.wrapper.classList.add("swiper-ready");
        },
        slideChange: () => {
        },
        resize: () => {
        },
      },
    });

    this.swiperInstance = swiper;
  }
}

customElements.define("sub-collections", SubCollections);

// NEWSLETTER POPUP
class NewsletterPopup extends HTMLElement {
  static get observedAttributes() {
    return ["open"];
  }

  connectedCallback() {
    this.wrapper = this.querySelector(
      ".newsletter_popup_section-newsletter-popup"
    );
    this.close = this.querySelector(".newsletter_popup_close_button");

    if (this.hasAttribute("open")) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.show();
        });
      });
    } else if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.delay);
    }

    this.close?.addEventListener("click", (e) => {
      e.preventDefault();
      this.hide();

      const currentUrl = window.location.href;
      const newUrl = currentUrl
        .replace("?customer_posted=true", "")
        .replace("#newsletter-newsletter-popup", "")
        .replace(/(&|\?)$/, ""); // Clean up trailing ? or & if left

      window.history.replaceState({}, document.title, newUrl);
    });
  }

  get delay() {
    return parseInt(this.getAttribute("delay") || "0", 10) * 1000;
  }

  show() {
    this.wrapper.classList.add("visible");
    this.setAttribute("open", "true");
  }

  hide() {
    this.wrapper.classList.remove("visible");
    this.removeAttribute("open");
  }

  get shouldAppearAutomatically() {
    return !(
      localStorage.getItem("theme:popup-filled") === "true" ||
      (this.hasAttribute("only-once") &&
        localStorage.getItem("theme:popup-appeared") === "true")
    );
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open" && newValue === "true") {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
}

if (!customElements.get("newsletter-popup")) {
  customElements.define("newsletter-popup", NewsletterPopup);
}

// FOOTER SECTION
class FooterSection extends HTMLElement {
  constructor() {
    super();
    this.parallax = this.dataset.enableParallax === "true";
    this.wrapper = this.closest(".footer-section");
    this.prevY = 0;
    this.scrollDirection = "down";

    if (!this.parallax) return;

    const allSections = document.querySelectorAll("main .shopify-section");
    this.lastSection = allSections.length
      ? allSections[allSections.length - 1]
      : null;

    if (this.lastSection) {
      this.observer = new IntersectionObserver(this.handleObserver, {
        threshold: [0, 0.01],
      });
    }
  }

  connectedCallback() {
    if (this.parallax && this.lastSection) {
      this.observer.observe(this.lastSection);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      const currentY = entry.boundingClientRect.top;

      this.scrollDirection = currentY < this.prevY ? "down" : "up";
      this.prevY = currentY;

      const isIntersecting = entry.isIntersecting;
      const ratio = entry.intersectionRatio;

      if (isIntersecting && ratio >= 0.01) {
        this.wrapper.style.opacity = "1";
        this.wrapper.style.zIndex = "0";
      }

      if (this.scrollDirection === "up" && !isIntersecting) {
        this.wrapper.style.opacity = "0";
        this.wrapper.style.zIndex = "-1";
      }
    });
  };
}

customElements.define("footer-section", FooterSection);

window.addEventListener("scroll", () => {
  document.dispatchEvent(new Event("theme:scroll"));
});

window.addEventListener("resize", () => {
  document.dispatchEvent(new Event("theme:resize"));
});


// HERO SLIDESHOW
class HeroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.hero_slideshow_slider');
    this.effect = this.dataset.effect; 
    this.autoplay = this.dataset.autoplay === 'true'; 
    this.loop = this.dataset.loop === 'true';
    this.speed = parseInt(this.dataset.speed * 1000);
    
  }

  connectedCallback() {
    if (this.slider) {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        loop: this.loop,
        speed: 800, 
        effect: this.effect, 
        autoplay: this.autoplay
          ? {
              delay: this.speed, 
              disableOnInteraction: false,
              pauseOnMouseHover: false
            }
          : false,
        creativeEffect:
          this.effect === 'creative'
            ? {
                prev: {
                  shadow: true,
                  translate: ['-20%', 0, -1],
                },
                next: {
                  translate: ['100%', 0, 0],
                },
              }
            : null,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,              
        },    
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        }
      });
    }
  }
}

customElements.define('hero-slideshow', HeroSlideshow);


// COLLECTION LIST SLIDER
class CollectionListSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.cls_slider');
    this.spacing = this.dataset.spacing;
    this.blocks = this.querySelectorAll('.cls_block');
  }

  connectedCallback() {
    if(this.slider) {
      const self = this;
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 4,
        spaceBetween: this.spacing,
        speed: 800,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,              
        }, 
        on: {
          sliderMove(swiper, event) {
            if(!self.blocks) return;
            self.blocks.forEach((block) => {
              block.classList.add('tilt')
            })
          }, 
          touchEnd(swiper, event){
            if(!self.blocks) return;
            self.blocks.forEach((block) => {
              block.classList.remove('tilt')
            })
          }
        },
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 15
          },
          640: {
            slidesPerView: 2,
            spaceBetween: this.spacing
          },
          768: {
            slidesPerView: 3,
            spaceBetween: this.spacing
          },
          1299: {
            slidesPerView: 4,
            spaceBetween: this.spacing
          }
        }
      })
    }
  }
} 

customElements.define('collection-list-slider', CollectionListSlider);


// TWO COLUMNS SECTION
class TwoColumnsBlock extends HTMLElement {
  constructor() {
    super();
    this.imgWrapper = this.querySelector('.two_columns_img_wrapper');
    this.textWrapper = this.querySelector('.two_columns_content_wrapper');
    this.checkIntersection = this.checkIntersection.bind(this);
  }

  connectedCallback() {
    if (!this.imgWrapper || !this.textWrapper) return;

    window.addEventListener('scroll', this.checkIntersection);
    window.addEventListener('resize', this.checkIntersection);

    this.checkIntersection();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.checkIntersection);
    window.removeEventListener('resize', this.checkIntersection);
  }

  checkIntersection() {
    const imageRect = this.imgWrapper.getBoundingClientRect();
    const textRect = this.textWrapper.getBoundingClientRect();

    // Check if the bottom of image intersects with the top of text
    const imageBottomTouchesTextTop =
      imageRect.bottom >= textRect.top && imageRect.bottom <= textRect.bottom;

    // Check if the bottom of text intersects with the top of image
    const textBottomTouchesImageTop =
      textRect.bottom >= imageRect.top && textRect.bottom <= imageRect.bottom;

    const isIntersecting = imageBottomTouchesTextTop || textBottomTouchesImageTop;

    if (isIntersecting) {
      this.textWrapper.classList.add('text_invert');
    } else {
      this.textWrapper.classList.remove('text_invert');
    }
  }
}

customElements.define('two-columns-block', TwoColumnsBlock);



// PRODUCT CARD WRAPPER
class ProductCardWrapper extends HTMLElement {
  constructor() {
    super();
    this.boxes = this.querySelectorAll('.product_card_wrapper');
    this.heights = [];
  }
  

  connectedCallback() {
    window.addEventListener('load', this.setEqualHeights.bind(this));
    window.addEventListener('resize', this.setEqualHeights.bind(this));
  }

  setEqualHeights() {
    this.boxes.forEach((box) => {
      const h2 = box.querySelector('.product_card_title');
      if(h2) this.heights.push(h2.offsetHeight);
    })

    const maxHeight = Math.max(...this.heights);

    this.boxes.forEach((box) => {
     // box.style.setProperty('--height', `${maxHeight}px`);
      this.style.setProperty('--height', `${maxHeight}px`);
    })
  }
}

customElements.define('product-card-wrapper', ProductCardWrapper);


// IMAGE HOTSPOTS
class ImageHotspots extends HTMLElement {
  constructor() {
    super();
    this.hotspots = this.querySelectorAll('.image_hotspot');
    this.cardsContainer = this.querySelector('.ih_cards_slider');
  }

  connectedCallback() {
    this.hotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', (e) => this.handleClick(e));
    });

    this.initializeHiddenCards();
  }

  initializeHiddenCards() {
    const cards = this.cardsContainer.querySelectorAll('.ih_card');
    cards.forEach((card) => {
      if (parseInt(card.dataset.index) > 2) {
        card.classList.add('hidden');
      }
    });
  }

  handleClick(e) {
    const clickedHotspot = e.currentTarget;
    const targetIndex = clickedHotspot.dataset.index;

    this.hotspots.forEach((h) => h.classList.remove('active'));
    clickedHotspot.classList.add('active');

    const cards = Array.from(this.cardsContainer.querySelectorAll('.ih_card'));
    const matchedCard = cards.find((c) => c.dataset.index === targetIndex);
    if (!matchedCard) return;

    // --- FLIP animation setup ---
    const firstRects = new Map();
    cards.forEach((c) => firstRects.set(c, c.getBoundingClientRect()));

    // Move matched card to first position
    this.cardsContainer.prepend(matchedCard);

    // Remove hidden class from matched card (make it visible)
    matchedCard.classList.remove('hidden');

    // Force reflow
    this.cardsContainer.offsetHeight;

    // Animate using FLIP
    cards.forEach((c) => {
      const lastRect = c.getBoundingClientRect();
      const firstRect = firstRects.get(c);
      const dx = firstRect.left - lastRect.left;
      c.style.transform = `translateX(${dx}px)`;
      c.style.transition = 'transform 0s';
    });

    requestAnimationFrame(() => {
      cards.forEach((c) => {
        c.style.transition = 'transform 0.4s ease';
        c.style.transform = '';
      });
    });

    // Cleanup
    setTimeout(() => {
      cards.forEach((c) => (c.style.transition = ''));
    }, 500);

    // Active card highlight
    cards.forEach((c) => c.classList.remove('active'));
    matchedCard.classList.add('active');

    // Hide cards beyond 2nd position
    this.updateHiddenCards();
  }

  updateHiddenCards() {
    const visibleCards = Array.from(this.cardsContainer.querySelectorAll('.ih_card'));
    visibleCards.forEach((card, index) => {
      if (index > 1) {
        card.classList.add('hidden');
      } else {
        card.classList.remove('hidden');
      }
    });
  }
}

customElements.define('image-hotspots', ImageHotspots);


// TESTIMONIALS SECTION
class TestimonialsSection extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.testimonials_slider');
    this.bottomSlider = this.querySelector('.testimonials_bottom_slider');
    this.spacing = this.dataset.spacing;
  }

  connectedCallback() {   
    if(!this.bottomSlider) return;
    this.bottomSwiper = new Swiper(this.bottomSlider, {
      slidesPerView: 3,
      spaceBetween: this.spacing,
      watchSlidesProgress: true,
      speed: 800,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      }
    })

    if(!this.slider) return;
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: this.spacing,
      speed: 800,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      }, 
      thumbs: {
        swiper: this.bottomSwiper
      }
    })
  }
}

customElements.define('testimonials-section', TestimonialsSection);


// FEATURED PRODUCT SECOND
class FeaturedProductSecond extends HTMLElement {
  constructor() {
    super();
    this.description = this.querySelector('.fp_description');
    this.descInner = this.description.querySelector('.fp_description_inner');
    this.readMore = this.querySelector('.fp_read_more');
  }

  connectedCallback() {
    if(!this.description) return;
    this.height = this.descInner.offsetHeight;
    this.description.style.setProperty('--maxHeight', `${this.height}px`);
    this.readMore.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if(this.description.hasAttribute('open')) {
      this.description.removeAttribute('open');
      this.readMore.querySelector('.rl').style.display = 'none';
      this.readMore.querySelector('.rm').style.display = 'block';
    } else {
      this.description.setAttribute('open', '');
      this.readMore.querySelector('.rl').style.display = 'block';
      this.readMore.querySelector('.rm').style.display = 'none';
    }
  }
}

customElements.define('featured-product-second', FeaturedProductSecond);


// PRODUCT DESCRIPTION
class productDescription extends HTMLElement {
  constructor() {
    super();
    this.description = this.querySelector('.product_description');
    this.inner = this.querySelector('.product_description_inner');
    this.readMore = this.querySelector('.pd_read_more');
  }

  connectedCallback() {
    if(!this.inner) return;
    let height = this.inner.clientHeight;
    
    this.description.style.setProperty('--height', `${height}px`);
    
    if(!this.readMore) return;
    this.readMore.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if(this.description.hasAttribute('open')) {
      this.description.removeAttribute('open');
      this.readMore.querySelector('.prl').classList.add('hidden');
      this.readMore.querySelector('.prm').classList.remove('hidden');
    } else {
      this.description.setAttribute('open', '');
      this.readMore.querySelector('.prl').classList.remove('hidden');
      this.readMore.querySelector('.prm').classList.add('hidden');
    }
  }
}

customElements.define('product-description', productDescription);


document.addEventListener('DOMContentLoaded', () => {
  const vdos = document.querySelectorAll('video');
  vdos.forEach((vdo) => {
    const img = vdo.querySelector('img');
    if(img) {
      img.setAttribute('alt', 'Video preview image');
    }
  })
})


// VERTICAL COLLECTIONS
class VerticalCollections extends HTMLElement {
  constructor() {
    super();
    this.tabs = [...this.querySelectorAll(".vertical_collections_block")];
    this.imageTabs = [...this.querySelectorAll(".vertical_collections_right_inner")];
  }

  connectedCallback() {
    this.handleHover();
  }

  handleHover() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("mouseover", () => {
        const id = tab.getAttribute("data-id");
        requestAnimationFrame(() => {
          this.imageTabs.forEach((imageTab) => {
            imageTab.style.opacity =
              imageTab.getAttribute("data-id") === id ? "1" : "0";
            imageTab.style.pointerEvents =
              imageTab.getAttribute("data-id") === id ? "all" : "none";
          });
        });
      });
    });
  }
}

customElements.define("vertical-collections", VerticalCollections);


// MULTICOLUMN IMAGES
class MulticolumnImages extends HTMLElement {
  constructor() {
    super();
    this.btns = this.querySelectorAll('.multicolumn_images_btn a');
  }

  connectedCallback() {
    if(this.btns.length) {
      this.btns.forEach((btn) => {
        btn.addEventListener('focusin', (e) => {
          const el = e.target;
          if(el.matches(':focus-visible')) {
            btn.closest('.multicolumn_images_btn').style.transform = 'translateY(0)';
          }
        })
      })
    }
  }
}

customElements.define('multicolumn-images', MulticolumnImages);


// PRODUCT CARD
class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('.pc__input.color_input');
    this.mainImage = this.querySelector('.product_card_main_image');    
  }

  connectedCallback() {
    if(this.inputs.length) {
      this.inputs.forEach((input) => {
        const image = input.dataset.variantImage;
        if(image) {
          const img = new Image();
          img.src = image;
        }
      })
    }

    if(this.inputs.length) {
      this.inputs.forEach((input) => {
        input.addEventListener('click', (e) => {
          const src = input.dataset.variantImage;
          if(!src) return;

          if(this.mainImage) {
            this.mainImage.src = src;
            this.mainImage.srcset = src;
          }
        })
      })
    }
  }
}

customElements.define('product-card', ProductCard);